import { render, staticRenderFns } from "./GroupTypeBenefits.vue?vue&type=template&id=04b863c0&"
import script from "./GroupTypeBenefits.vue?vue&type=script&lang=js&"
export * from "./GroupTypeBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports